import { CartItem, CartShippingAddress } from '../lib/cart/types'

export const shouldShowCaliforniaProp65Asterisks = ({
  item,
  shippingAddress,
}: {
  item: CartItem
  shippingAddress?: CartShippingAddress
}): boolean | number | null | undefined =>
  shippingAddress &&
  item.item_attributes?.prop_sixty_five &&
  shippingAddress.country.code === 'US' &&
  shippingAddress.region?.code === 'CA'

export const shouldShowCaliforniaProp65Warning = ({
  items,
  shippingAddress,
}: {
  items: CartItem[]
  shippingAddress?: CartShippingAddress
}): boolean | null | undefined =>
  shippingAddress &&
  shippingAddress.country.code === 'US' &&
  shippingAddress.region?.code === 'CA' &&
  items.some((item) => item.item_attributes?.prop_sixty_five)
